import React from 'react';
import '../styles/pages/GoogleAds.css';

const GoogleAds = () => {
  return (
    <div className="google-ads-page">
      <div className="container">
        <header className="page-header">
          <h1>Oferta Usług Reklamowych Google Ads dla Firm Finansowych</h1>
          <p>Skuteczne kampanie reklamowe, które pomogą Twojej firmie finansowej pozyskać nowych klientów</p>
        </header>

        <div className="info-box">
          <p><strong>Dlaczego Google Ads jest tak skuteczny dla firm finansowych?</strong></p>
          <p>Reklamy w Google to najlepszy sposób na dotarcie do osób, które aktywnie poszukują produktów i usług finansowych. Nasze kampanie Google Ads pozwalają:</p>
          <ul className="icon-list">
            <li><strong>Dotrzeć do klientów w odpowiednim momencie</strong> - dokładnie wtedy, gdy szukają kredytów, pożyczek czy usług doradczych</li>
            <li><strong>Precyzyjnie targetować geograficznie</strong> - kampanie mogą być kierowane do mieszkańców konkretnych miast, dzielnic czy regionów</li>
            <li><strong>Kontrolować budżet</strong> - płacisz tylko za kliknięcia w reklamę, a nie za samo jej wyświetlenie</li>
            <li><strong>Mierzyć efekty</strong> - szczegółowa analityka pozwala dokładnie śledzić, które reklamy generują najlepsze wyniki</li>
            <li><strong>Wyprzedzić konkurencję</strong> - Twoja oferta może pojawić się na samej górze wyników wyszukiwania, przed naturalnymi wynikami</li>
          </ul>
        </div>

        <h2>Google Ads dla branży finansowej</h2>
        
        <div className="platform-highlight">
          <div className="platform-card google">
            <div className="platform-icon">G</div>
            <h3 className="platform-title">Google Ads</h3>
            <p>Google Ads pozwala Twojej firmie finansowej wyświetlać reklamy osobom, które aktywnie szukają w Google informacji na temat kredytów, pożyczek, leasingów i innych usług finansowych. Dla przykładu, gdy potencjalny klient wpisze w wyszukiwarce hasło "kredyt hipoteczny we Wrocławiu", Twoja reklama może pojawić się na samej górze wyników wyszukiwania.</p>
            <p>Korzyści Google Ads dla firm finansowych:</p>
            <ul>
              <li>Najwyższa intencja zakupowa - reklamy trafiają do osób już zainteresowanych produktami finansowymi</li>
              <li>Precyzyjne targetowanie na konkretne hasła, np. "kredyt hipoteczny", "doradca kredytowy", "konsolidacja kredytów"</li>
              <li>Możliwość dopasowania kampanii do różnych produktów finansowych (kredyty gotówkowe, hipoteczne, leasingi, itp.)</li>
              <li>Łatwe mierzenie efektów - śledzenie telefonów, formularzy kontaktowych i innych konwersji</li>
            </ul>
          </div>
        </div>

        <h2>Nasze pakiety Google Ads</h2>
        
        <div className="packages">
          <div className="package-card">
            <div className="package-header">
              <div className="package-name">Ads Local</div>
              <div className="package-price">od 799 zł <span className="package-price-note">/ miesiąc</span></div>
              <div className="budget-info">Sugerowany budżet reklamowy: od 1 500 zł</div>
            </div>
            
            <p>Pakiet dla firm finansowych działających lokalnie</p>
            
            <ul>
              <li>Kampanie targetowane do Twoich grup docelowych</li>
              <li>Odpowiednio dobrane reklamy w Google</li>
              <li>Tylko najskuteczniejsze słowa kluczowe</li>
              <li>Stała optymalizacja kampanii</li>
              <li>Analityka i raportowanie</li>
              <li>Dedykowany opiekun</li>
              <li>Konfiguracja i optymalizacja reklam</li>
              <li>Do 4 kampanii / miesiąc</li>
              <li>Projekty graficzne do kampanii</li>
            </ul>
          </div>
          
          <div className="package-card recommended">
            <span className="recommended-badge">Rekomendowany</span>
            <div className="package-header">
              <div className="package-name">Ads Leader</div>
              <div className="package-price">od 1 199 zł <span className="package-price-note">/ miesiąc</span></div>
              <div className="budget-info">Sugerowany budżet reklamowy: od 4 000 zł</div>
            </div>
            
            <p>Dla firm finansowych działających na większym obszarze</p>
            
            <ul>
              <li>Kampanie targetowane do Twoich grup docelowych</li>
              <li>Dedykowane kampanie na konkretne obszary</li>
              <li>Odpowiednio dobrane reklamy w Google</li>
              <li>Tylko najskuteczniejsze słowa kluczowe</li>
              <li>Stała optymalizacja kampanii</li>
              <li>Analityka i raportowanie</li>
              <li>Dedykowany opiekun</li>
              <li>Konfiguracja i optymalizacja reklam</li>
              <li>Monitorowanie przepływu ruchu i zachowań użytkowników na stronie</li>
              <li>Do 7 kampanii / miesiąc</li>
              <li>Projekty graficzne do kampanii</li>
              <li>Podstawowy audyt SEO z wytycznymi istotnymi dla poprawy skuteczności kampanii</li>
            </ul>
          </div>
        </div>
        
        <h2>Porównanie pakietów Google Ads</h2>
        
        <div className="table-container">
          <table className="features-table">
            <thead>
              <tr>
                <th>Funkcjonalność</th>
                <th>Ads Local</th>
                <th>Ads Leader</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="feature-name">Cena miesięczna</td>
                <td>od 799 zł</td>
                <td>od 1 199 zł</td>
              </tr>
              <tr>
                <td className="feature-name">Sugerowany budżet reklamowy</td>
                <td>od 1 500 zł</td>
                <td>od 4 000 zł</td>
              </tr>
              <tr>
                <td className="feature-name">Liczba kampanii</td>
                <td>do 4</td>
                <td>do 7</td>
              </tr>
              <tr>
                <td className="feature-name">Dedykowany opiekun</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
              <tr>
                <td className="feature-name">Analityka i raportowanie</td>
                <td>Podstawowa</td>
                <td>Rozszerzona</td>
              </tr>
              <tr>
                <td className="feature-name">Monitorowanie zachowań</td>
                <td>-</td>
                <td>✓</td>
              </tr>
              <tr>
                <td className="feature-name">Projekty graficzne</td>
                <td>✓</td>
                <td>✓</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <h2>Nasz proces pracy z reklamami Google Ads</h2>
        
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Analiza i badanie rynku</h3>
              <p>Badamy Twoją konkurencję i identyfikujemy najlepsze możliwości</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Strategia kampanii</h3>
              <p>Tworzymy strategię dopasowaną do Twoich celów biznesowych i budżetu</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Konfiguracja kampanii</h3>
              <p>Ustawiamy kampanie, grupy reklam i słowa kluczowe</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Tworzenie reklam</h3>
              <p>Przygotowujemy przekonujące teksty reklamowe i materiały graficzne</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">5</div>
            <div className="step-content">
              <h3>Uruchomienie i monitorowanie</h3>
              <p>Uruchamiamy kampanie i stale monitorujemy ich wydajność</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">6</div>
            <div className="step-content">
              <h3>Optymalizacja</h3>
              <p>Regularnie optymalizujemy kampanie, aby osiągać coraz lepsze wyniki</p>
            </div>
          </div>
          
          <div className="process-step">
            <div className="step-number">7</div>
            <div className="step-content">
              <h3>Raportowanie</h3>
              <p>Dostarczamy przejrzyste raporty z wynikami kampanii</p>
            </div>
          </div>
        </div>
        
        <h2>Warunki współpracy</h2>
        
        <div className="info-box">
          <ul>
            <li><strong>Minimalny okres współpracy:</strong> 3 miesiące</li>
            <li><strong>Rozliczenie:</strong> Płatność miesięczna za obsługę kampanii</li>
            <li><strong>Budżet reklamowy:</strong> Opłacany bezpośrednio na koncie reklamowym klienta</li>
            <li><strong>Start kampanii:</strong> Do 7 dni roboczych od podpisania umowy</li>
          </ul>
        </div>
        
        <div className="cta-section">
          <div className="cta-box">
            <h2>Gotowy na skuteczne kampanie Google Ads?</h2>
            <p>Skontaktuj się z nami i rozpocznij współpracę!</p>
            <button className="btn btn-accent">Skontaktuj się</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleAds;